import CloneChildren from "@components/children";
import MmvOptionsModal from "@components/mmvOptionsModal";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useMmvState from "./useMmvState";
import {
  formatVariantsDataByFuelType,
  MMV_DATA
} from "@utils/organizeVehicleMakeModel";
import {
  EDIT_MMV_DETAILS_NODE,
  monthToNumber,
  REVIEW_EDIT_NODE,
  sampleAnalytics,
  transformMakeData
} from "@utils/index";
import { setPayloadData } from "@store/slices/globalState";
import SkeletonCard from "@components/skeletonCard";
import {
  useGetMmvData,
  useGetMakes,
  useGetModels,
  useGetVariants,
  useGetNcbSlabs
} from "./useGetMmvData";
import { useRunOnceHook } from "@components/common/custom-hooks";
import { updateVisibility } from "@actions/showHideWidgets";
import { useRouter } from "next/router";
import { setAnalytics } from "@actions/setAnalyticsData";
import actions from "@actions/actionsMap";
import { updateShouldRedirectToPlansNode } from "@store/slices/config";
import { removeFromSessionStorage } from "@actions/removeFromSessionStorage";

const getNcbSlabs = async (regYear, regMonth, proposal_ekey) => {
  const response = await useGetNcbSlabs(regYear, regMonth, proposal_ekey);
  return response;
};

const MmvContainer = ({ children, ...props }: any) => {
  // TODO: USE usereducer hook here
  const {
    initial_fuel_type,
    initial_is_comm,
    initial_make,
    initial_model,
    initial_variant,
    initial_reg_year,
    initial_reg_month,
    initial_variant_ekey
  } = props || {};

  console.log("sending init", {
    initial_fuel_type,
    initial_is_comm,
    initial_make,
    initial_model,
    initial_variant,
    initial_reg_year,
    initial_reg_month,
    initial_variant_ekey
  });

  const dispatch = useDispatch();
  const router = useRouter();
  const { proposal_ekey, current_node } = router.query;

  const {
    currentStateForMake,
    setCurrentStateForMake,
    currentStateForModal,
    setCurrentStateForModal,
    currentStateForFuelType,
    setCurrentStateForFuelType,
    currentStateForRegYear,
    setCurrentStateForRegYear,
    currentStateForVariant,
    setCurrentStateForVariant,
    isCommercial,
    setIsCommercial,
    currentActiveMonth,
    setCurrentActiveMonth
  } = useMmvState({
    initialMake: initial_make,
    initialModal: initial_model,
    initialFuelType: initial_fuel_type,
    //@ts-ignore
    initialVariant: { variant_name: initial_variant },
    initialIsCommercial: initial_is_comm,
    initialRegYear: initial_reg_year,
    initialActiveMonth: initial_reg_month,
    initialVariantEkey: initial_variant_ekey
  });

  // for id of step mapped with config and input field
  const [currentActiveStepId, setCurrentActiveStepId] = useState<any>();
  const [showMmvModal, setShowMmvModal] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  const { data, loading, error } = useGetMmvData();
  const [makeId, setMakeId] = useState<number>();
  const [modelId, setModelId] = useState<number>();
  const { makeData, isMakeLoading, hasMakeError } = useGetMakes();
  const { modeldata, isModelsLoading, hasModelserror } = useGetModels(makeId);
  const { variantdata, isVariantLoading, hasVariantserror } =
    useGetVariants(modelId);
  const sampleData = MMV_DATA;
  // const mmv = data?.mmv || {};
  const [config, setConfig] = useState<any>();
  const mmv = makeData;
  const reg = data?.registration_years || {};

  const isReviewEditPageAndEdited = () => {
    return current_node === REVIEW_EDIT_NODE;
  };

  useEffect(() => {
    const makeObj = makeData?.find(
      (a) => a?.make_name === currentStateForMake
    )?.make_id;
    if (makeObj) {
      setMakeId(makeObj);
    }
  }, [makeData]);

  useEffect(() => {
    const modelObj = modeldata?.find(
      (a) => a?.model_name === currentStateForModal
    )?.model_id;
    if (modelObj) {
      setModelId(modelObj);
    }
  }, [makeId, modeldata]);

  const getIndexByQuery = (query: any) => {
    console.log("1112", { query, SAMPLE_CONFIG });
    const index = SAMPLE_CONFIG.findIndex((item) => item?.query === query);
    return index !== -1 ? index : null;
  };

  const handleregYearClick = () => {
    setShowModal(true);
  };

  // useEffect(() => {
  //   if (!showMmvModal) {
  //     sampleAnalytics(
  //       "view",
  //       "view_page",
  //       "view_page_confirm_asset_details_page_cta"
  //     );
  //   }
  //  }, [showMmvModal]);

  const handleInputClick = (query: any) => {
    if (query === "fuel_type") query = "variant";
    const currentIdOfModal = getIndexByQuery(query);
    console.log("111", currentIdOfModal);
    setCurrentActiveStepId(currentIdOfModal);
    setShowMmvModal(true);
  };

  const getModelsFromMake = (makeName: any) => {
    // const { modelData, isModelsLoading, hasModelserror } =
    //   useModelsFromMake(makeName);
    // // @ts-ignore
    // return modelData;
    return makeName ? mmv?.[makeName]?.models : mmv;
  };

  const formatVariantsByFuelType = (
    makeName: any,
    modelName: any,
    defaultvariant: any
  ) => {
    return formatVariantsDataByFuelType(
      makeName,
      modelName,
      mmv,
      defaultvariant
    );
  };

  const handleMakeModelClick = (selectedValue: any, queryType: string) => {
    if (queryType === "make") {
      if (selectedValue?.make_name !== currentStateForMake) {
        if (isReviewEditPageAndEdited()) {
          dispatch(
            updateShouldRedirectToPlansNode({
              shouldRedirectToPlansNode: true
            })
          );
        }
        setCurrentStateForMake("");
        setCurrentStateForModal("");
        setCurrentStateForVariant("");
        setCurrentStateForFuelType("");
      }
      setCurrentStateForMake(selectedValue?.make_name);
      sampleAnalytics("action", "tap_btn", "tap_btn_make_selected", {
        make_name: selectedValue?.make_name
      });
      setMakeId(selectedValue?.make_id);
      setAnalytics({
        make_name: selectedValue?.make_name
      });
      dispatch(
        //@ts-ignore
        setPayloadData({
          [queryType]: selectedValue?.make_name
        })
      );
    } else if (queryType === "model") {
      if (selectedValue?.model_name !== currentStateForModal) {
        setCurrentStateForVariant("");
        setCurrentStateForFuelType("");
        if (isReviewEditPageAndEdited()) {
          dispatch(
            updateShouldRedirectToPlansNode({
              shouldRedirectToPlansNode: true
            })
          );
        }
      }
      sampleAnalytics("action", "tap_btn", "tap_btn_model_selected", {
        model_name: selectedValue?.model_name
      });
      setCurrentStateForModal(selectedValue?.model_name);
      setModelId(selectedValue?.model_id);
      setAnalytics({
        model_name: selectedValue?.model_name
      });
      dispatch(
        //@ts-ignore
        setPayloadData({
          [queryType]: selectedValue?.model_name
        })
      );
    }
  };

  useRunOnceHook({
    hookCondition: mmv && !loading && !initial_make,
    callback: () => {
      sampleAnalytics("view", "view_modal", "view_modal_select_make_modal");
      setShowMmvModal(true);
    }
  });

  const hanlderegistrationYearClick = async (regYear: any, regMonth: any) => {
    if (!regMonth && !regYear) return;
    if (regMonth) {
      setCurrentActiveMonth(regMonth);
      setAnalytics({
        registration_month: monthToNumber(regMonth)
      });

      dispatch(
        //@ts-ignore
        setPayloadData({
          registration_month: monthToNumber(regMonth)
        })
      );
    }
    if (regYear) {
      setCurrentStateForRegYear(regYear);
      setAnalytics({
        registration_year: regYear
      });
      dispatch(
        //@ts-ignore
        setPayloadData({
          registration_year: regYear
        })
      );
    }
    // EDIT MMV DETAILS SPECIFIC CODE
    if (current_node === EDIT_MMV_DETAILS_NODE && regYear && regMonth) {
      //@ts-ignore
      const regMonthFormatted = monthToNumber(regMonth) - 1;
      const newNcbSlabs = await getNcbSlabs(
        regYear,
        regMonthFormatted,
        proposal_ekey
      );

      setAnalytics({
        ncb_slab: newNcbSlabs?.ncbArray
      });

      dispatch(
        setPayloadData({
          options: newNcbSlabs?.ncbArray
        })
      );
    }

    if (
      (current_node === EDIT_MMV_DETAILS_NODE ||
        current_node === REVIEW_EDIT_NODE) &&
      regYear &&
      regMonth
    ) {
      removeFromSessionStorage({ key: "ncb_input_modal" });
      removeFromSessionStorage({ key: "ncb_update_modal" });
    }

    if (
      isReviewEditPageAndEdited() &&
      (initial_reg_year !== regYear ||
        initial_reg_month !== monthToNumber(regMonth))
    ) {
      dispatch(
        updateShouldRedirectToPlansNode({
          shouldRedirectToPlansNode: true
        })
      );
    }
  };

  const handleVariantClick = (selectedFuelType: any, selectedVariant: any) => {
    if (selectedVariant) {
      sampleAnalytics("action", "tap_btn", "tap_btn_variant_selected", {
        variant_name: selectedVariant?.variant_name
      });
      setCurrentStateForVariant(selectedVariant);
      setAnalytics({
        variant: selectedVariant?.variant_name,
        variant_ekey: selectedVariant?.variant_ekey
      });
      dispatch(
        //@ts-ignore
        setPayloadData({
          variant: selectedVariant?.variant_name,
          variant_ekey: selectedVariant?.variant_ekey
        })
      );
      if (
        isReviewEditPageAndEdited() &&
        (initial_variant !== selectedVariant?.variant_name ||
          initial_fuel_type !== selectedFuelType)
      ) {
        dispatch(
          updateShouldRedirectToPlansNode({
            shouldRedirectToPlansNode: true
          })
        );
      }
    } else {
      setAnalytics({ fuel_type: selectedFuelType });
      sampleAnalytics(
        "action",
        "tap_btn",
        "tap_btn_fuel_type_filter_select_variant_modal",
        { selected_filter: selectedFuelType }
      );
    }
    setCurrentStateForFuelType(selectedFuelType);
    console.log("visib", selectedFuelType);
    setAnalytics({
      fuel_type: selectedFuelType
    });
    dispatch(
      //@ts-ignore
      setPayloadData({
        fuel_type: selectedFuelType
      })
    );
    if (
      isReviewEditPageAndEdited() &&
      (initial_variant !== selectedVariant?.variant_name ||
        initial_fuel_type !== selectedFuelType)
    ) {
      dispatch(
        updateShouldRedirectToPlansNode({
          shouldRedirectToPlansNode: true
        })
      );
    }

    // to show hide external cng question in deisel fuesl type
    // const key = selectedFuelType === "petrol" ? "ids" : "reverseIds";
    // //@ts-ignore
    // updateVisibility({
    //   [key]: "enter_mmv_details_qna_2"
    // });
  };

  const handleOptionalValuesClick = (selectedValue: any, query: any) => {
    sampleAnalytics(
      "action",
      "tap_btn",
      query === "is_commercial"
        ? "tap_btn_commercial_car_response_selected"
        : "tap_btn_external_cng_response_selected",
      query === "is_commercial"
        ? { is_commercial: selectedValue === "Yes" }
        : { external_cng_kit: selectedValue === "Yes" }
    );
    setAnalytics({
      [query]: selectedValue === "Yes"
    });
    dispatch(
      //@ts-ignore
      setPayloadData({
        [query]: selectedValue === "Yes"
      })
    );
    // todo: change according to query and corresponsding SETSTATE mapping
    query === "is_commercial" && setIsCommercial(selectedValue);
  };

  //TODO: MOVE TO STORE
  // FOR input values as they can't interact with each other
  // and we don;t have context since they are rendered by clonechildren
  // only for display on input field
  const sharedState = {
    make:
      currentStateForModal && currentStateForMake
        ? `${currentStateForMake} ${currentStateForModal}`
        : currentStateForMake,
    model: currentStateForModal,
    variant: currentStateForVariant?.variant_name,
    fuel_type: currentStateForFuelType,
    registration_year:
      currentStateForRegYear && currentActiveMonth
        ? `${currentActiveMonth} ${currentStateForRegYear}`
        : `${currentStateForRegYear}`,
    is_commercial: isCommercial
  };

  console.log("shared variant", sharedState);

  const SAMPLE_CONFIG = [
    {
      id: 1,
      title: "What {purple}brand is your car{/purple}?",
      query: "make",
      data: makeData,
      showSearchInput: true,
      searchInputPlaceholder: "Search your car's brand",
      selectedState: currentStateForMake,
      setSelectedState: handleMakeModelClick,
      isOptional: false
    },
    {
      id: 2,
      title: `Which model of {purple} ${currentStateForMake}{/purple}?`,
      query: "model",
      // data: getModelsFromMake(makeId),
      date: modeldata,
      showSearchInput: true,
      searchInputPlaceholder: "Search your car’s model",
      selectedState: currentStateForModal,
      setSelectedState: handleMakeModelClick,
      isOptional: false
    },
    {
      id: 3,
      title: `Which {purple}${currentStateForModal}{/purple} variant do you drive?`,
      query: "variant",
      data: formatVariantsByFuelType(
        currentStateForMake,
        currentStateForModal,
        currentStateForVariant
      ),
      showSearchInput: false,
      searchInputPlaceholder: "",
      selectedState: currentStateForVariant,
      setSelectedState: handleVariantClick,
      isOptional: false
    },
    {
      id: 4,
      title: "When was your {purple}car registered{/purple}?",
      query: "registration_year",
      data: reg,
      showSearchInput: false,
      searchInputPlaceholder: "",
      selectedState: { currentStateForRegYear, currentActiveMonth },
      setSelectedState: hanlderegistrationYearClick,
      isOptional: false
    },
    {
      id: 5,
      title: "Do you use your car for {purple}commercial activities{/purple}?",
      query: "is_commercial",
      data: "",
      showSearchInput: false,
      searchInputPlaceholder: "",
      selectedState: isCommercial,
      setSelectedState: handleOptionalValuesClick,
      isOptional: true
    }
  ];

  const getSampleConfig = () => {
    return [
      {
        id: 1,
        title: "What {purple}brand is your car{/purple}?",
        query: "make",
        data: makeData,
        showSearchInput: true,
        searchInputPlaceholder: "Search your car's brand",
        selectedState: currentStateForMake,
        setSelectedState: handleMakeModelClick,
        isOptional: false
      },
      {
        id: 2,
        title: `Which model of {purple} ${currentStateForMake}{/purple}?`,
        query: "model",
        // data: getModelsFromMake(makeId),
        data: modeldata,
        showSearchInput: true,
        searchInputPlaceholder: "Search your car’s model",
        selectedState: currentStateForModal,
        setSelectedState: handleMakeModelClick,
        isOptional: false
      },
      {
        id: 3,
        title: `Which {purple}${currentStateForModal}{/purple} variant do you drive?`,
        query: "variant",
        data: variantdata,
        showSearchInput: false,
        searchInputPlaceholder: "",
        selectedState: { currentStateForFuelType, currentStateForVariant },
        setSelectedState: handleVariantClick,
        isOptional: false
      },
      {
        id: 4,
        title: "When was your {purple}car registered{/purple}?",
        query: "registration_year",
        data: reg,
        showSearchInput: false,
        searchInputPlaceholder: "",
        selectedState: { currentStateForRegYear, currentActiveMonth },
        setSelectedState: hanlderegistrationYearClick,
        isOptional: false
      },
      {
        id: 5,
        title:
          "Do you use your car for {purple}commercial activities{/purple}?",
        query: "is_commercial",
        data: "",
        showSearchInput: false,
        searchInputPlaceholder: "",
        selectedState: isCommercial,
        setSelectedState: handleOptionalValuesClick,
        isOptional: true
      }
    ];
  };

  useEffect(() => {
    const newConfig = getSampleConfig();
    setConfig(newConfig);
  }, [makeId, modelId]);

  const configS = getSampleConfig();
  console.log("sharedstate", {
    SAMPLE_CONFIG,
    IDEA: getSampleConfig(),
    configS
  });

  return true && !loading ? (
    <div className="container">
      <CloneChildren
        styles={{
          display: "flex",
          width: "100%",
          gap: "2rem",
          flexDirection: "column"
        }}
        mStyles={{
          gap: "2rem"
        }}
        children={children}
        props={{ ...props, handleInputClick, inputState: sharedState }}
      />
      {/* TODO: ADD DYNAMIC SHARING LOGIC can use Context api or object commen shared */}
      {showMmvModal && (
        <MmvOptionsModal
          showModal={showMmvModal}
          setShowModal={setShowMmvModal}
          queryType={props.id}
          handleClickedMake={setCurrentStateForMake}
          handleClickedModel={setCurrentStateForModal}
          handleClickedVariant={setCurrentStateForVariant}
          handleClickedFuelType={setCurrentStateForFuelType}
          handleClickedRegYear={setCurrentStateForRegYear}
          config={configS}
          currentId={currentActiveStepId}
          lockBackgroundInteraction={props.lockBackgroundInteraction}
        />
      )}

      {/* <MmvNotFoundModal showModal={true} setShowModal={() => {console.log('mkay hhhh')}}/> */}
      <style jsx>
        {`
          .container {
            width: 100%;
          }
        `}
      </style>
    </div>
  ) : (
    // TODO: USE LOADER
    <>
      <SkeletonCard />
    </>
  );
};

export default MmvContainer;
